export const NLB_TERMS_PATH = '/syarat-ketentuan/nominal-lebih-bayar';

export function buildNlbTermsHref(): string {
  return NLB_TERMS_PATH;
}
